import { ApiClientProps } from "hooks/useApi";

interface ToastChitFlagsPayload {
  guestNoteEnabled: boolean;
  reservationNoteEnabled: boolean;
  allergiesEnabled: boolean;
  specialOccasionEnabled: boolean;
}

export const updateToastChits = async ({
  apiClient,
  locationId,
  partnerId,
  note,
  flags,
}: {
  apiClient: ApiClientProps;
  locationId: string;
  partnerId: string;
  note: string;
  flags: ToastChitFlagsPayload;
}) => {
    if (!locationId || !partnerId) {
      throw new Error("Location ID and Partner ID are required to update Toast Chits notes.");
    }

    const body = JSON.stringify({
      note,
      ...flags,
    });

    const response = await apiClient.put({
      path: `/middleware-admin/partners/${partnerId}/locations/${locationId}/gda`,
      headers: {
        "Content-Type": "application/json",
        posType: "toast",
      },
      body,
      noRetry: true
    });

    return response;
};
